// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__24ZhC","info":"UpdateTermsInfo_info__3_YRR"};